import { Button } from '@hopin-team/ui-button';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  border: 1px solid var(--color-gray-300);
`;
